import { useEffect, useState } from 'react';
import { Category } from '@/components/molecules';
import { INavigatorItem } from '@/types';
import { NavList, Wrapper } from '@/components/common/navbar/Navbar.styled';
import { useCommonParams, useFirstIncome, useOrganicUser, useScrollDirection } from '@/hooks';
import { useRouter } from 'next/router';

const Navbar = (props: any) => {
  const [activeUrl, setActiveUrl] = useState('');
  const { media, page } = useCommonParams();
  const scrollDirection = useScrollDirection();
  const router = useRouter();
  const [firstIncome] = useFirstIncome();
  const [isOrganicUser] = useOrganicUser();
  const { navList } = props;

  const handleClickNav = async (destinationUrl: string) => {
    const isSamePage = router.asPath.includes(destinationUrl);
    if (isSamePage) return;

    const pathname = `/${media}/${destinationUrl}`;
    const query = { ...router.query };
    delete query.media;
    delete query.page;
    await router.push({ pathname, query });
  };

  const isNotLGU = media !== 'lgu';

  useEffect(() => {
    setActiveUrl(page);
  }, [page]);

  return (
    <Wrapper
      sticky={scrollDirection === 'up' && scrollY !== 0}
      firstIncome={firstIncome}
      isOrganicUser={isOrganicUser}
      isNotLGU={isNotLGU}
    >
      <NavList>
        {navList?.map((item: INavigatorItem) => (
          <Category
            key={item.destinationUrl}
            src={item.activeImgUrl}
            isActive={item.destinationUrl === activeUrl}
            onClick={() => handleClickNav(item.destinationUrl)}
          >
            {item.title}
          </Category>
        ))}
      </NavList>
    </Wrapper>
  );
};
export default Navbar;
